import React from 'react';

import { useFormSelector } from '../../../custom-hooks';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import DynamicField from '../../DynamicField';
import { getPropByModel } from '../../selectors/form-manager.selectors';
import { getIndexForControlsInsideTable } from '../../utils/form-manager.utils';
import SSTextView from '../ssTextView';

const CustomCell = ({
  row,
  column: {
    columnKey,
    isParentlessTable,
    index,
    isViewOnly,
    subgridId,
    isDetail,
    accessor,
    isColumnHiddenFCM,
  },
}) => {
  const childrenNodes = useFormSelector(getPropByModel, {
    id: columnKey,
    prop: FORM_MODEL_ATTRIBUTES.CHILDREN_NODES,
  });

  const rowIndex = isParentlessTable ? row.gridArrIndex : row.index;
  const gridArrIndex = getIndexForControlsInsideTable(index, rowIndex, isParentlessTable);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {childrenNodes.length > 0 ? (
        childrenNodes.map((child) => (
          <DynamicField
            id={child}
            key={child}
            index={gridArrIndex}
            isParentViewOnly={
              isViewOnly ||
              row.disableEdit ||
              row.isViewIconShown ||
              (!row.isEditMode && !row.isComplexTable)
            }
            isParentColumnHiddenFCM={isColumnHiddenFCM}
            isInComplexGridRow={!!subgridId}
            isDetail={isDetail}
          />
        ))
      ) : (
        <SSTextView value={row[accessor]} />
      )}
    </div>
  );
};

export default React.memo(CustomCell);
